<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <strong class="card-title mb-3">{{'Fund Manager'}} {{(mfSCHCode != '')? '-'+mfSCHCode: ''}} {{(rawData.length)? rawData[0]['SCH_NAME']: ''}}</strong>
        </div>
        <div class="col-md-5">          
        </div>
        <div class="col-md-1">
          <!-- <goback></goback> -->
          <div class="pull-right">
            <router-link class="btn btn-sm" :to="'/mutual-funds/rawdata'"><i class="fa fa-caret-left"></i> Go Back</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-6">
          </div>
        </div>
        <div class="mb5"></div>
        <div class="row mb5">
          <div class="col-md-3">
            <span v-if="rawData.date"><strong>Date: {{rawData.date? getDate(sum.date): ''}}</strong></span>
          </div>
          <div class="col-md-4">
            <span v-if="rawData.date">Portfolio Overall Rating: {{rawData.date? getChecknFixed(sum.portfolio_overall_rating): ''}}</span>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2">
            <download :tableId="rawDataType" :fileName="rawDataType"></download>
          </div>
        </div>
        <div class="table-responsive scrollbar app" v-dragscroll="true" v-if="tableFields.length || tableFields1.length">
          <table :id="rawDataType" class="table table-bordered fonts11 app-inner">
            <thead>
              <tr>
                <th>Sr.</th>
                <th
                  class="data-cell"
                  v-for="(field, index) in tableFields"
                  v-bind:key="index+'field'+field.title"
                >{{field.name}}</th>
                <th
                  class="data-cell"
                  v-for="(field, index) in tableFields1"
                  v-bind:key="index+'sumfield'+field.title"
                >{{field.name}}</th>
              </tr>
            </thead>
            <tbody v-if="rawData.date">
              <tr >
                  <th>Sum</th>
                <td v-for="(cl, index) in tableFields"
                  v-bind:key="index+'cldata'+cl.title" class="text-bold">
                  <span v-if="cl.datatype=='numeric'">{{(sum[cl.title+'_sum'])? getChecknFixed(sum[cl.title+'_sum']): (sum[cl.title])? getChecknFixed(sum[cl.title]): '-'}}</span>
                  <span v-else-if="cl.datatype=='date'">{{(sum[cl.title+'_sum'])? getDate(sum[cl.title+'_sum']): (sum[cl.title])? getDate(sum[cl.title]): '-'}}</span>
                  <span v-else>{{(sum[cl.title+'_sum'])? sum[cl.title+'_sum']: (sum[cl.title])? sum[cl.title]: ''}}</span>
                </td>
              </tr>
            </tbody>
            <tbody v-if="tableFields1.length">
              <tr v-for="(tr, ind) in rawData" v-bind:key="'trBod'+'-'+ind">
                  <td>{{ind+1}}</td>
                <td v-for="(cl, index) in tableFields1"
                  v-bind:key="index+'cldata'+cl.title" >
                  <span v-if="cl.datatype=='numeric'">{{(tr[cl.title+'_sum'])? getChecknFixed(tr[cl.title+'_sum']): (tr[cl.title])? getChecknFixed(tr[cl.title]): '-'}}</span>
                  <span v-else-if="cl.datatype=='date'">{{(tr[cl.title+'_sum'])? getDate(tr[cl.title+'_sum']): (tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                  <span v-else>{{(tr[cl.title+'_sum'])? tr[cl.title+'_sum']: (tr[cl.title])? tr[cl.title]: ''}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row mb5" v-if="!tableFields.length">
          <div class="col-md-12"><div class="alert alert-danger" role="alert">No data found!</div></div>
        </div>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";

import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { rawMixins } from "../../assets/mixins/rawMixins.js";

export default {
  components: { VueTabs, VTab},
  mixins: [commonMixins, rawMixins],
  created() {
    console.log('PARAM', this.$route.params.id);
    if(this.$route.params.id) {
      this.showSchemeHoldings(this.$route.params.id);
      this.mfSCHCode = this.$route.params.id;
    } else {
      this.rawData = [];
      this.showSchemeHoldings();
    }
    console.log("Rawtype", this.rawDataType, this.mfSCHCode);
  },
  methods: {
    showSchemeHoldings(mfcode = null) {
      console.log('mfcode', mfcode);
      this.rawData = [];
      // this.tableFields = [];
      let myself = this;
      var APIUrl = this.rawDataApi + 'fund-manager';
      if(mfcode!=null){
        APIUrl = APIUrl + '/' + mfcode;
      }
      http.get(
        APIUrl,
        {},
        (error, response) => {
          console.log("Response", response.data);
          if(response.status == 'success') {
            this.rawData = response.data.date ? response.data : response.data;
            this.sum = response.data.date? response.data: [];
            console.log(this.rawData);
            if(response.data.date) {
              this.tableFields1 = [];
            } else {
              this.tableFields = [];
            }
          // console.log("this.rawData", this.rawData);
          }
        });
    }
  },
  data() {
    return {
      tableFields: [
          {
            title: 'mf_schcode',
            name: this.getLabel('mf_schcode'),
            isLink: 0,
            datatype: '',
            sort_order: 1
          },
          {
            title: 'mf_cocode',
            name: this.getLabel('MF_COCODE'),
            isLink: 0,
            datatype: '',
            sort_order: 3
          },
          {
            title: 'fund_mgr',
            name: this.getLabel('fund_manager'),
            isLink: 0,
            datatype: '',
            sort_order: 4
          }
      ],
      tableFields1: [
          {
            title: 'mf_schcode',
            name: this.getLabel('mf_schcode'),
            isLink: 0,
            datatype: '',
            sort_order: 1
          },
          {
            title: 'mf_cocode',
            name: this.getLabel('MF_COCODE'),
            isLink: 0,
            datatype: '',
            sort_order: 3
          },
          {
            title: 'fund_mgr',
            name: this.getLabel('fund_manager'),
            isLink: 0,
            datatype: '',
            sort_order: 4
          }
      ],
      sum: {},
      rawDataType: "fund-manager",
      rawDataApi: "mutual-funds/",
      rawData: [],
      mfSCHCode: ''
    };
  },
  computed: {
    // mfHoldingData: function() {
    //   return this.rawData.filter(function(row, index) {
    //     return index !== "_id" && index !== "co_code";
    //   });
    // },
    // keyFinancialRatios: function(){
    //   return (this.rawData.length > 0 && this.rawData[0]['keyfinancialratiolist'])? this.rawData[0]['keyfinancialratiolist']: [];
    // }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/fund-manager.vue